import {
    GET_CART,
    GET_CART_SUCCESS,
    GET_CART_ERROR,
    ADD_TO_CART,
    ADD_TO_CART_SUCCESS,
    ADD_TO_CART_ERROR,
    ADD_TO_CART_RESET
} from '../../actions'
import get from 'lodash/get'

const initialState = {
    total_items: undefined,
    loading: false,
    errorMessage: undefined,
    itemsAddingToCart: {}
}

const cart = (state = initialState, action) => {
    switch (action.type) {
        case GET_CART:
            return {
                ...state,
                loading: true
            };
        case GET_CART_SUCCESS:
            return {
                ...state,
                ...action.payload,
                errorMessage: undefined,
                loading: false
            };
        case GET_CART_ERROR:
            return {
                ...initialState,
                errorMessage: "Unable to load cart",
            };
        case ADD_TO_CART:
            return {
                ...state,
                itemsAddingToCart: {
                    ...state.itemsAddingToCart,
                    [action.payload.sku]: {
                        simpleSku: action.payload.simpleSku,
                        state: 'adding',
                        message: ''
                    }
                }
            }
        case ADD_TO_CART_ERROR:
            return {
                ...state,
                itemsAddingToCart: {
                    ...state.itemsAddingToCart,
                    [action.payload.sku]: {
                        ...state.itemsAddingToCart[action.payload.sku],
                        state: 'error',
                        message: 'Error'
                    }
                }
            }
        case ADD_TO_CART_SUCCESS:
            return {
                ...state,
                items: get(action, ['payload', 'response', 'items' ]),
                itemsAddingToCart: {
                    ...state.itemsAddingToCart,
                    [action.payload.sku]: {
                        ...state.itemsAddingToCart[action.payload.sku],
                        state: 'added',
                        message: ''
                    }
                }
            }
        case ADD_TO_CART_RESET:
            return {
                ...state,
                itemsAddingToCart: {
                    ...state.itemsAddingToCart,
                    [action.payload.sku]: undefined
                }
            }

        default:
            return state
    }
}

export default cart



// WEBPACK FOOTER //
// ./src/reducers/account/cart.js